<template>
  <div class="personalMessage">
    <div class="personalMessage_container">
      <!-- 头部 -->
      <div class="personalMessage_header">
        <div class="personalMessage_header_left">
          <div class="personalMessage_schoolIcon">
            <img alt="" src="../assets/imgs/loginSchoolIconNew.png" width="100%">
          </div>
          <div class="personalMessage_systemName">学生信息采集系统</div>
        </div>
        <div class="personalMessage_header_right">
        </div>
      </div>
      <!-- 表单内容 -->
      <div class="personalMessage_content">
        <div class="form_title">2026年中招科技特长生报名</div>
        <div class="personalMessage_content_maintitle">基本信息采集</div>
        <div class="personalMessage_content_container">
          <el-form ref="form" :labelWidth="labelWidth" :model="form" :rules="Rules" label-position="left">
            <div class="personalMessage_content_module">
              <div class="personalMessage_content_title">一、学生个人信息</div>
              <div class="personalMessage_content_module_message">
                <div>
                  <el-row :gutter="80">
                    <el-col :span="12">
                      <el-form-item label="姓名：" prop="name">
                        <el-input v-model="form.name" :disabled="disabledForm"></el-input>
                      </el-form-item>
                      <el-form-item class="sex" label="性别：" prop="sex">
                        <el-select v-model="form.sex" :disabled="disabledForm" placeholder="请选择">
                          <el-option label="男" value="男"></el-option>
                          <el-option label="女" value="女"></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="出生年月：" prop="birthday">
                        <el-date-picker v-model="form.birthday" :disabled="disabledForm" placeholder="选择日期"
                                        type="date">
                        </el-date-picker>
                      </el-form-item>
                      <el-form-item label="初中（学籍）所在校：" prop="chuzhongSchool">
                        <el-input v-model="form.chuzhongSchool" :disabled="disabledForm"></el-input>
                      </el-form-item>
                      <div style="display:flex">
                        <el-form-item class="xuejisuozaiqu" label="初中校所在区：" prop="xuejisuozaiqu">
                          <el-select v-model="form.xuejisuozaiqu" :disabled="disabledForm" filterable
                                     placeholder="请选择">
                            <el-option v-for="item in cityList" :key="item.value" :label="item.label"
                                       :value="item.value">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item v-if="form.xuejisuozaiqu === '110230'" class="xuejisuozaiquQita" label=""
                                      prop="xuejisuozaiquQita">
                          <el-input v-model="form.xuejisuozaiquQita" :disabled="disabledForm"
                                    placeholder="初中校所在区"></el-input>
                          <div v-if="xuejisuozaiquQitaRules" class="el-form-item__error">请填写初中校所在县区具体名称
                          </div>
                        </el-form-item>
                      </div>
                      <el-form-item class="idNo" label="身份证号：" prop="idNo">
                        <el-input v-model="form.idNo" :disabled="disabledForm"></el-input>
                      </el-form-item>
                      <el-form-item label="中考报名号（11位）：" prop="zhongkaoNo">
                        <el-input v-model="form.zhongkaoNo" :disabled="disabledForm"
                                  placeholder="请输入11位中考报名号"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item class="personalPhoto" label="个人近期证件照：" prop="photo" style="height:224px">
                        <div v-if="photoPreview" class="photoPreview">
                          <img :src="photoPreview" alt="" height="100%" width="100%">
                          <div class="photoPreview_modal">
                            <i class="el-icon-zoom-in" @click="photoDialogVisible = true"></i>
                            <i v-if="!disabledForm" class="el-icon-delete" @click="deletePhoto"></i>
                          </div>
                        </div>
                        <el-upload v-if="!disabledForm" ref="photo" v-loading="photoLoading"
                                   :before-upload="photoBeforeUpload" :http-request="photoUpload"
                                   :limit="1" :show-file-list="false" action="''"
                                   class="upload_container" element-loading-background="rgba(0, 0, 0, 0.8)"
                                   element-loading-spinner="el-icon-loading"
                                   element-loading-text="上传中，请稍等"
                                   list-type="picture-card">
                          <i slot="default" class="el-icon-plus"></i>
                          <div class="el-upload__text">上传照片</div>
                          <div slot="tip" class="el-upload__tip">只能上传jpg文件，且不超过2M</div>
                        </el-upload>
                        <el-dialog :visible.sync="photoDialogVisible">
                          <img :src="photoPreview" alt="" width="100%">
                        </el-dialog>
                      </el-form-item>
                      <div style="display:flex">
                        <el-form-item class="hujiqvxiao" label="户籍所在区县：" prop="hujiqvxiao">
                          <el-select v-model="form.hujiqvxiao" :disabled="disabledForm" placeholder="请选择">
                            <el-option v-for="item in cityList" :key="item.value" :label="item.label"
                                       :value="item.value">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item v-if="form.hujiqvxiao === '110230'" class="hujiqvxiaoQiTaName" label=""
                                      prop="hujiqvxiaoQiTaName">
                          <el-input v-model="form.hujiqvxiaoQiTaName" :disabled="disabledForm"
                                    placeholder="户籍所在区县"></el-input>
                          <div v-if="hujiqvxiaoQiTaNameRules" class="el-form-item__error">请填写户籍所在县区具体名称
                          </div>
                        </el-form-item>
                      </div>
                      <el-form-item label="教育ID号（8位）：" prop="eduId">
                        <el-input v-model="form.eduId" :disabled="disabledForm"
                                  placeholder="请输入8位教育ID号"></el-input>
                      </el-form-item>
                      <div style="display:flex">
                        <el-form-item class="zhongkaobaomingsuozaiqu" label="中考报名所在区："
                                      prop="extendProd.zhongkaobaomingsuozaiqu">
                          <el-select v-model="form.extendProd.zhongkaobaomingsuozaiqu" :disabled="disabledForm"
                                     filterable
                                     placeholder="请选择">
                            <el-option v-for="item in cityList" :key="item.value" :label="item.label"
                                       :value="item.value">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item v-if="form.extendProd.zhongkaobaomingsuozaiqu === '110230'"
                                      class="zhongkaobaomingsuozaiquQita"
                                      label=""
                                      prop="extendProd.zhongkaobaomingsuozaiquQita">
                          <el-input v-model="form.extendProd.zhongkaobaomingsuozaiquQita" :disabled="disabledForm"
                                    placeholder="初中校所在区"></el-input>
                          <div v-if="zhongkaobaomingsuozaiquQitaRules" class="el-form-item__error">
                            请填写初中校所在县区具体名称
                          </div>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
            <div class="personalMessage_content_module">
              <div class="personalMessage_content_title">二、家庭成员信息</div>
              <div class="personalMessage_content_module_message">
                <div class="personalMessage_content_tableList">
                  <div class="personalMessage_content_tableList_header">
                    <div class="personalMessage_content_tableList_header_item table_relation">与本人关系</div>
                    <div class="personalMessage_content_tableList_header_item table_name">姓名</div>
                    <div class="personalMessage_content_tableList_header_item table_phone">联系电话</div>
                  </div>
                  <div class="personalMessage_content_tableList_data">
                    <div class="personalMessage_content_tableList_data_item table_relation">
                      <div class="personalMessage_content_tableList_data_item_cell">父亲</div>
                      <div class="personalMessage_content_tableList_data_item_cell">母亲</div>
                    </div>
                    <div class="personalMessage_content_tableList_data_item table_name">
                      <div class="personalMessage_content_tableList_data_item_cell">
                        <el-form-item label="" prop="faName">
                          <el-input v-model="form.faName" :disabled="disabledForm"></el-input>
                        </el-form-item>
                      </div>
                      <div class="personalMessage_content_tableList_data_item_cell">
                        <el-form-item label="" prop="maName">
                          <el-input v-model="form.maName" :disabled="disabledForm"></el-input>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="personalMessage_content_tableList_data_item table_phone">
                      <div class="personalMessage_content_tableList_data_item_cell">
                        <el-form-item label="" prop="faPhone">
                          <el-input v-model="form.faPhone" :disabled="disabledForm"></el-input>
                        </el-form-item>
                      </div>
                      <div class="personalMessage_content_tableList_data_item_cell">
                        <el-form-item label="" prop="maPhone">
                          <el-input v-model="form.maPhone" :disabled="disabledForm"></el-input>
                        </el-form-item>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="personalMessage_content_module">
              <div class="personalMessage_content_title">三、报考专项</div>
              <div class="personalMessage_content_zhuanxiang">
                <el-row :gutter="80">
                  <el-col :span="12">
                    <el-form-item label=""
                                  label-width="0px"
                                  prop="baokaozhuanxiang">
                      <el-radio-group v-model="form.baokaozhuanxiang" placeholder="请选择" :disabled="disabledForm">
                        <el-radio label="数学探索">数学探索</el-radio>
                        <el-radio label="人工智能">人工智能</el-radio>
                        <el-radio label="物理实践">物理实践</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="personalMessage_content_maintitle">学业信息</div>
            <div class="personalMessage_content_maintitle_remark color_red">
              <div>备注：</div>
              <div>1. 以下填报信息，填报人须保证内容真实，如填报内容与实际情况不符，一经查实将取消报考资格</div>
              <div>2. 未参加考试或无成绩、不知道等内容，填写0</div>
            </div>
            <div class="personalMessage_content_module">
              <div class="personalMessage_content_title">一、初三第一学期期末考试</div>
              <div class="personalMessage_content_module_message">
                <div>请填写原始成绩，单科满分不一致请在备注中说明</div>
                <div class="personalMessage_content_table">
                  <el-table
                    :data="tableData"
                    border
                    class="first-table"
                    style="width: 100%"
                  >
                    <el-table-column
                      label="语文 / 100"
                      width="112">
                      <template #default>
                        <el-form-item label="" prop="chinese">
                          <el-input-number v-model="form.chinese" :controls="false" :precision="0"
                                           :disabled="disabledForm" :max="100"
                                           :min="0" style="width: 100%"/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="数学 / 100"
                      width="112">
                      <template #default>
                        <el-form-item label="" prop="math">
                          <el-input-number v-model="form.math" :controls="false" :precision="0" :disabled="disabledForm"
                                           :max="100"
                                           :min="0"
                                           style="width: 100%"/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="外语（不含听口）/ 60"
                      width="180">
                      <template #default>
                        <el-form-item label="" prop="english">
                          <el-input-number v-model="form.english" :controls="false" :precision="0"
                                           :disabled="disabledForm" :max="60"
                                           :min="0" style="width: 100%"/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="物理 / 100"
                      width="112">
                      <template #default>
                        <el-form-item label="" prop="physics">
                          <el-input-number v-model="form.physics" :controls="false" :precision="0"
                                           :disabled="disabledForm" :max="100"
                                           :min="0" style="width: 100%"/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="政治 / 100"
                      width="112">
                      <template #default>
                        <el-form-item label="" prop="politics">
                          <el-input-number v-model="form.politics" :controls="false" :precision="0"
                                           :disabled="disabledForm" :max="100"
                                           :min="0" style="width: 100%"/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="总分 / 460"
                      width="112">
                      <template #default>
                        <el-form-item label="">
                          <el-input-number v-model="form.totalScore" :controls="false" :precision="0" :disabled="true"
                                           :max="460"
                                           :min="0" style="width: 100%"/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="校排名"
                      width="111">
                      <template #default>
                        <el-form-item label="" prop="xiaoRank">
                          <el-input v-model="form.xiaoRank" :disabled="disabledForm"
                                    style="width: 100%"/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="区排名"
                      width="112">
                      <template #default>
                        <el-form-item label="" prop="quRank">
                          <el-input v-model="form.quRank" :disabled="disabledForm"
                                    style="width: 100%"/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column label="备注">
                      <template #default>
                        <el-form-item label="" prop="extendProd.remark">
                          <el-input v-model="form.extendProd.remark" :disabled="disabledForm"></el-input>
                        </el-form-item>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
            <div class="personalMessage_content_module">
              <div class="personalMessage_content_title">二、初三一模考试成绩</div>
              <div class="personalMessage_content_module_message">
                <div>请填写原始成绩，单科满分不一致请在备注中说明</div>
                <div class="personalMessage_content_table">
                  <el-table
                    :data="tableData"
                    border
                    class="first-table"
                    style="width: 100%">
                    <el-table-column
                      label="语文 / 100"
                      width="112">
                      <template #default>
                        <el-form-item label="" prop="yimochinese">
                          <el-input-number v-model="form.yimochinese" :controls="false" :precision="0"
                                           :disabled="disabledForm"
                                           :max="100"
                                           :min="1" style="width: 100%"/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="数学 / 100"
                      width="112">
                      <template #default>
                        <el-form-item label="" prop="yimomath">
                          <el-input-number v-model="form.yimomath" :controls="false" :precision="0"
                                           :disabled="disabledForm" :max="100"
                                           :min="1" style="width: 100%"/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="外语（不含听口）/ 60"
                      width="180">
                      <template #default>
                        <el-form-item label="" prop="yimoenglish">
                          <el-input-number v-model="form.yimoenglish" :controls="false" :precision="0"
                                           :disabled="disabledForm"
                                           :max="60"
                                           :min="1" style="width: 100%"/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="物理 / 70"
                      width="112">
                      <template #default>
                        <el-form-item label="" prop="yimophysics">
                          <el-input-number v-model="form.yimophysics" :controls="false" :precision="0"
                                           :disabled="disabledForm"
                                           :max="70"
                                           :min="0" style="width: 100%"/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="政治 / 70"
                      width="112">
                      <template #default>
                        <el-form-item label="" prop="yimopolitics">
                          <el-input-number v-model="form.yimopolitics" :controls="false" :precision="0"
                                           :disabled="disabledForm"
                                           :max="70"
                                           :min="0" style="width: 100%"/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="总分 / 400"
                      width="112">
                      <template #default>
                        <el-form-item label="" prop="yimototalScore">
                          <el-input-number v-model="form.yimototalScore" :controls="false" :precision="0"
                                           :disabled="true"
                                           :max="400"
                                           :min="0" style="width: 100%"/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="校排名"
                      width="111">
                      <template #default>
                        <el-form-item label="" prop="yimoxiaoRank">
                          <el-input v-model="form.yimoxiaoRank" :disabled="disabledForm"

                                    style="width: 100%"/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="区排名"
                      width="112">
                      <template #default>
                        <el-form-item label="" prop="yimoquRank">
                          <el-input v-model="form.yimoquRank" :disabled="disabledForm"
                                    style="width: 100%"/>
                        </el-form-item>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="备注"
                    >
                      <template #default>
                        <el-form-item label="" prop="extendProd.yimoRemark">
                          <el-input v-model="form.extendProd.yimoRemark" :disabled="disabledForm"></el-input>
                        </el-form-item>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>

            </div>
            <div class="personalMessage_content_module">
              <div class="personalMessage_content_title">三、中考情况</div>
              <div class="personalMessage_content_module_message" style="width: 300px">
                <div class="personalMessage_content_score">
                  <el-form-item label="英语听口 / 40" label-width="120px" prop="zhongkaoyingyu">
                    <el-input-number v-model="form.zhongkaoyingyu" :controls="false" :precision="0"
                                     :disabled="disabledForm" :max="40"
                                     :min="0" style="width: 100%"/>
                  </el-form-item>
                </div>
              </div>
            </div>
            <div class="personalMessage_content_maintitle">专业成绩</div>
            <div class="personalMessage_content_module">
              <div class="personalMessage_content_title">一、专业成绩</div>
              <div class="personalMessage_content_table personalMessage_content_score">
                <el-table :data="zhuanyeData" border style="width: 100%">
                  <el-table-column label="赛事/展演名称" width="360">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.zhuanyechengjiname" :disabled="disabledForm"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="名次" width="90">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.zhuanyechengjirank" :disabled="disabledForm"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="成绩" width="90">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.zhuanyechengjiscore" :disabled="disabledForm"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="主办单位" width="269">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.zhuanyechengjiplace" :disabled="disabledForm"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="证书(png、jpg、jpeg、pdf)" width="200">
                    <template slot-scope="scope">
                      <el-upload :action="''" :before-upload="beforeUploadCertificate" :disabled="disabledForm"
                                 :http-request="e => certificateUpload(e, scope.$index)"
                                 :show-file-list="false">
                        <el-button :disabled="disabledForm" type="text">
                          <span v-if="!zhuanyeData[scope.$index].zhuanyechengjizhengshu">点击上传</span>
                          <span v-if='zhuanyeData[scope.$index].zhuanyechengjizhengshu'
                                class="fileName">{{ zhuanyeData[scope.$index].zhuanyechengjizhengshu }}</span>
                        </el-button>
                      </el-upload>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="110">
                    <template slot-scope="scope">
                      <el-button :disabled="disabledForm" type="text" @click="deleteRow(scope)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="personalMessage_content_table_addrow">
                <el-button v-show='this.zhuanyeData.length < 3' :disabled="disabledForm" type="text"
                           @click="addRow">添加
                </el-button>
              </div>
            </div>
            <div class="personalMessage_content_maintitle">自述材料</div>
            <div class="otherDesc">
              <div><span
                style="color: red">（必填）</span><span>1.请写出在科技领域你感兴趣的话题、问题或领域；2.举例阐述自我兴趣的学习经历、发展过程或投入状态等</span>
              </div>
              <el-form-item label="" label-width="0" prop="otherDesc">
                <el-input v-model="form.otherDesc" :disabled="disabledForm" maxlength="500"
                          placeholder="请将字数控制在500字以内…"
                          rows="6" show-word-limit type="textarea"></el-input>
              </el-form-item>

            </div>

            <div v-if="!disabledForm" class="formFooter">
              <el-form-item>
                <el-button class="purple" type="primary" @click="submitForm('form')">提交</el-button>
                <el-button class="default" @click="saveForm">保存</el-button>
              </el-form-item>
            </div>
          </el-form>
          <el-dialog :close-on-click-modal="false" :visible.sync="resultDialog" class="resultDialog"
                     title="报名结果通知">
            <div v-if="dealState === 20">
              <div class="scienceResultNotice">
                <h1>同学你好！祝贺你入围我校科技特长生校内测试！</h1>
                <div class="scienceResultNotice_title">北京师范大学附属实验中学科技特长生测试安排</div>
                <div class="scienceResultNotice_info">
                  <div><span>学校地址：</span>北京师范大学附属实验中学校本校区（西城区二龙路14号） 西门进入后有引导</div>
                  <div><span>报到时间：</span>2026年5月16日上午7:30-7:45</div>
                  <div><span>报到地点：</span>北师大实验中学勤学楼一层大厅</div>
                  <div><span>测试流程：</span></div>
                </div>
                <table class="scienceResultNotice_table">
                  <thead>
                  <tr>
                    <th>项目</th>
                    <th>时间</th>
                    <th>时长</th>
                    <th>测试内容</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>1</td>
                    <td>8:00-10:20</td>
                    <td>140 分钟（含休息）</td>
                    <td>数理思维能力</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>10:40-11:40</td>
                    <td>60 分钟</td>
                    <td class="scienceResultNotice_tableNest">
                      <div class="scienceResultNotice_showcase">
                        <div class="scienceResultNotice_showcaseTitle">科学潜质展示</div>
                        <div class="scienceResultNotice_showcaseItems">
                          <div>数学探索</div>
                          <div>人工智能</div>
                          <div>物理实践</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <div class="scienceResultNotice_notes">
                  <div class="scienceResultNotice_notesTitle">考生注意事项：</div>
                  <p>（1）现场资格确认结束后，开始测试，测试开始时间为 8:00；（过时不候）</p>
                  <p>（2）考生需携带身份证（或户口本）原件，签到时将核对个人信息，请同时携带北京市中小学学生卡/证件卡（带照片、教育 ID 号），以便核验；</p>
                  <p>（3）请携带报名时下载的《北京师范大学附属实验中学特长生测试学生承诺书》（家长、学生已签字），签到时提交；</p>
                  <p>（4）如有获奖证书，请携带证书原件及复印件，核验后原件归还，复印件学校留存；（以上材料请提交初中阶段获得的）</p>
                  <p>（5）考生需带好测试时使用的文具，如黑蓝钢笔（或签字笔）、圆规、直尺、三角板和量角器（均不能标有公式），准许考生使用计算器（无存储功能）；</p>
                  <p>（6）送考家长须在校外等候，测试期间禁止入校（考生预计离校时间为 12:00）。</p>
                </div>
                <div class="scienceResultNotice_footer">
                  <div>如有问题请咨询 66526016/6150</div>
                  <div>预祝大家考试顺利！</div>
                  <div class="scienceResultNotice_signature">北师大实验中学 课程教学评价处</div>
                </div>
              </div>
              <div class="resultDialog_action" style="min-height:40px" v-loading="notifyStatusLoading">
                <template v-if="!notifyStatusLoading">
                  <template v-if="testConfirmChoice === null">
                    <el-popover placement="top" trigger="click" v-model="acceptPopoverVisible">
                      <div class="confirmPop">
                        <p>确认参加学校测试？</p>
                        <div class="confirmPop_btns">
                          <el-button size="mini" @click="acceptPopoverVisible = false">否</el-button>
                          <el-button type="primary" size="mini" @click="confirmAccept">是</el-button>
                        </div>
                      </div>
                      <el-button slot="reference" type="primary">已阅读测试安排，同意参加学校测试</el-button>
                    </el-popover>
                    <el-popover placement="top" trigger="click" v-model="rejectPopoverVisible">
                      <div class="confirmPop">
                        <p>确认拒绝参加学校测试？</p>
                        <div class="confirmPop_btns">
                          <el-button size="mini" @click="rejectPopoverVisible = false">否</el-button>
                          <el-button type="danger" size="mini" @click="confirmReject">是</el-button>
                        </div>
                      </div>
                      <el-button slot="reference">拒绝</el-button>
                    </el-popover>
                  </template>
                  <el-button v-else disabled>
                    {{
                      testConfirmChoice === 'accept' ? '已阅读测试安排，并同意参加学校测试' : '已阅读测试安排，拒绝参加学校测试'
                    }}
                  </el-button>
                </template>
              </div>
              <div class="resultDialog_promiseDownload">
                <a
                  href="https://bs-application-resource.oss-cn-beijing.aliyuncs.com/%E5%8C%97%E4%BA%AC%E5%B8%88%E8%8C%83%E5%A4%A7%E5%AD%A6%E9%99%84%E5%B1%9E%E5%AE%9E%E9%AA%8C%E4%B8%AD%E5%AD%A6%E7%89%B9%E9%95%BF%E7%94%9F%E6%B5%8B%E8%AF%95%E5%AD%A6%E7%94%9F%E6%89%BF%E8%AF%BA%E4%B9%A6.pdf"
                  target="_blank"
                >
                  下载《特长生测试学生承诺书》
                </a>
              </div>
            </div>
            <div v-else class="rejectResult">
              <p>同学你好！很遗憾，你未通过我校特长生校内测试初步筛选，谢谢你的参与。</p>
              <p>预祝你在中考中取得优异成绩，进入北京师范大学附属实验中学学习。我们期待你的加入！</p>
              <div class="resultDialog_action" v-if="!notifyStatusLoading && testConfirmChoice === null">
                <el-button type="info" @click="submitAttendTestState('noted')">已知晓</el-button>
              </div>
            </div>
          </el-dialog>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Qs from 'qs'
import commitmentDownloadIcon from '../assets/imgs/commitment-download-icon.svg'
import commitmentFileIcon from '../assets/imgs/commitment-file-icon.svg'
import {
  Button,
  Checkbox,
  CheckboxGroup,
  Col,
  DatePicker,
  Dialog,
  Form,
  FormItem,
  Input,
  InputNumber,
  Loading,
  Message,
  MessageBox,
  Option,
  Popover,
  Progress,
  Radio,
  RadioGroup,
  Row,
  Select,
  Table,
  TableColumn,
  Upload
} from 'element-ui'

Vue.use(Button).use(Upload).use(InputNumber).use(Row).use(Col).use(Form).use(Input).use(FormItem).use(Select).use(Option).use(RadioGroup).use(Radio).use(CheckboxGroup).use(Checkbox).use(Progress).use(Loading).use(DatePicker).use(Table).use(TableColumn).use(Dialog).use(Popover)
export default {
  name: 'science',
  data () {
    return {
      resultDialog: false,
      dealState: null,
      testConfirmChoice: null,
      acceptPopoverVisible: false,
      rejectPopoverVisible: false,
      notifyStatusLoading: true,
      disabledForm: false,
      tableData: [{}],
      form: {
        applicationId: '',
        applicantToken: '',
        fillFormSn: '',
        operationType: '',
        name: '', // 姓名
        sex: '', // 性别
        birthday: '', // 出生年月
        chuzhongSchool: '', // 初中（学籍）所在校
        xuejisuozaiqu: '', // 初中校所在区
        xuejisuozaiquQita: '',
        idNo: '',
        zhongkaoNo: '', // 中考报名号
        photo: '', // 个人证件照
        hujiqvxiao: '', // 户籍所在区
        hujiqvxiaoQiTaName: '', // 户籍所在区其他名称
        eduId: '', // 教育ID
        // 表格
        extrarelation: '',
        extrarelationName: '',
        extrarelationGongzuoDanwei: '',
        extrarelationPhone: '',
        faName: '',
        maName: '',
        faPhone: '',
        maPhone: '',
        faGongzuoDanwei: '',
        maGongzuoDanwei: '',
        faGongzuopost: "",
        maGongzuopost: "",
        extrarelationGongzuopost: "",
        // 考试
        chinese: undefined,
        math: undefined,
        english: undefined,
        physics: undefined,
        politics: undefined,
        totalScore: undefined,
        xiaoRank: undefined,
        quRank: undefined,
        // 一模考试
        yimochinese: undefined,
        yimomath: undefined,
        yimoenglish: undefined,
        yimophysics: undefined,
        yimopolitics: undefined,
        yimototalScore: undefined,
        yimoxiaoRank: undefined,
        yimoquRank: undefined,
        zhongkaoyingyu: undefined,
        // 报考专项
        baokaozhuanxiang: '',
        baokaoxiaoxiang: '',
        // 专业成绩
        zhuanyechengji: [],
        otherDesc: '',
        // 额外字段
        extendProd: {
          baokaofenlei: '科技',
          baomingqumu: '',
          shifouhechangbanzou: '',
          remark: '',
          yimoRemark: '',
          zhongkaobaomingsuozaiqu: '',
          zhongkaobaomingsuozaiquQita: ''

        }
      },
      photoPreview: false,
      photoDialogVisible: false,
      photoLoading: false,
      labelWidth: '170px',
      Rules: {
        name: [
          {
            required: true,
            message: '请填写姓名',
            trigger: 'blur'
          },
          {
            max: 50,
            message: '姓名长度应在50字以内',
            trigger: 'blur'
          }
        ],
        sex: [
          {
            required: true,
            message: '请选择性别',
            trigger: 'change'
          }
        ],
        birthday: [
          {
            required: true,
            message: '请选择出生年月日',
            trigger: 'change'
          }
        ],
        chuzhongSchool: [
          {
            required: true,
            message: '请填写初中（学籍）所在校',
            trigger: 'blur'
          },
          {
            max: 50,
            message: '初中（学籍）所在校长度不能超过50',
            trigger: 'blur'
          }
        ],
        xuejisuozaiqu: [
          {
            required: true,
            message: '请选择初中校所在区',
            trigger: 'change'
          }
        ],
        xuejisuozaiquQita: [
          {
            max: 100,
            message: '初中校所在区名称不能超过100',
            trigger: 'blur'
          },
          {
            max: 100,
            message: '初中校所在区具体名称不能超过100',
            trigger: 'blur'
          }
        ],
        idNo: [
          {
            required: true,
            message: '请填写身份证号',
            trigger: 'blur'
          }
        ],
        zhongkaoNo: [
          {
            required: true,
            message: '请填写中考报名号',
            trigger: 'blur'
          },
          {
            max: 100,
            message: '中考报名号长度不能超过100',
            trigger: 'blur'
          }
        ],
        photo: [
          {
            required: true,
            message: '请上传个人证件照',
            trigger: 'blur'
          }
        ],

        hujiqvxiao: [
          {
            required: true,
            message: '请选择户籍所在区县',
            trigger: 'change'
          }
        ],
        hujiqvxiaoQiTaName: [
          {
            max: 100,
            message: '户籍所在县区具体名称不能超过100',
            trigger: 'blur'
          }
        ],
        eduId: [
          {
            required: true,
            message: '请填写教育ID号',
            trigger: 'blur'
          },
          {
            max: 30,
            message: '教育ID号长度不能超过30',
            trigger: 'blur'
          }
        ],
        baokaozhuanxiang: [
          {
            required: true,
            message: '请选择报考专项',
            trigger: 'change'
          }
        ],
        extrarelation: [
          {
            max: 50,
            message: '关系长度应在50字以内',
            trigger: 'blur'
          }
        ],
        extrarelationName: [
          {
            max: 50,
            message: '姓名长度应在50字以内',
            trigger: 'blur'
          }
        ],
        extrarelationGongzuoDanwei: [
          {
            max: 50,
            message: '工作单位长度应在50字以内',
            trigger: 'blur'
          }
        ],
        extrarelationPhone: [
          {
            pattern: /^[1][3,4,5,7,8][0-9]{9}$/,
            message: '请输入合法的手机号',
            trigger: 'blur'
          }
        ],
        faName: [
          {
            max: 50,
            message: '父亲姓名长度应在50字以内',
            trigger: 'blur'
          }
        ],
        maName: [
          {
            max: 50,
            message: '母亲姓名长度应在50字以内',
            trigger: 'blur'
          }
        ],
        faPhone: [
          {
            pattern: /^[1][3,4,5,7,8][0-9]{9}$/,
            message: '请输入合法的父亲手机号',
            trigger: 'blur'
          }
        ],
        maPhone: [
          {
            pattern: /^[1][3,4,5,7,8][0-9]{9}$/,
            message: '请输入合法的母亲手机号',
            trigger: 'blur'
          }
        ],
        faGongzuoDanwei: [
          {
            max: 50,
            message: '父亲工作单位长度应在50字以内',
            trigger: 'blur'
          }
        ],
        maGongzuoDanwei: [
          {
            max: 50,
            message: '母亲工作单位长度应在50字以内',
            trigger: 'blur'
          }
        ],
        chinese: [
          {
            required: true,
            message: '请填写初三期末考试语文成绩',
            trigger: 'blur'
          }
        ],
        math: [
          {
            required: true,
            message: '请填写初三期末考试数学成绩',
            trigger: 'blur'
          }
        ],
        english: [
          {
            required: true,
            message: '请填写初三期末考试外语成绩',
            trigger: 'blur'
          }
        ],
        physics: [
          {
            required: true,
            message: '请填写初三期末考试物理成绩',
            trigger: 'blur'
          }
        ],
        politics: [
          {
            required: true,
            message: '请填写初三期末考试政治成绩',
            trigger: 'blur'
          }
        ],
        totalScore: [
          {
            required: true,
            message: '请填写初三期末考试总分',
            trigger: 'blur'
          }
        ],
        yimochinese: [
          {
            required: true,
            message: '请填写初三一模考试语文成绩',
            trigger: 'blur'
          }
        ],
        yimomath: [
          {
            required: true,
            message: '请填写初三一模考试数学成绩',
            trigger: 'blur'
          }
        ],
        yimoenglish: [
          {
            required: true,
            message: '请填写初三一模考试外语成绩',
            trigger: 'blur'
          }
        ],
        yimophysics: [
          {
            required: true,
            message: '请填写初三一模考试物理成绩',
            trigger: 'blur'
          }
        ],
        yimopolitics: [
          {
            required: true,
            message: '请填写初三一模考试政治成绩',
            trigger: 'blur'
          }
        ],
        yimototalScore: [
          {
            required: true,
            message: '请填写初三一模考试总分',
            trigger: 'blur'
          }
        ],
        zhongkaoyingyu: [
          {
            required: true,
            message: '请填写中考英语成绩',
            trigger: 'blur'
          }
        ],
        otherDesc: [
          {
            required: true,
            message: '请填写自述材料',
            trigger: 'blur'
          },
          {
            max: 500,
            message: '自述材料长度不能超过500字',
            trigger: 'blur'
          }
        ],
        xiaoRank: [
          {
            required: true,
            message: '请填写校排名',
            trigger: 'blur'
          }
        ],
        baokaoxiaoxiang: [
          {
            required: true,
            message: '请选择',
            trigger: 'change'
          }
        ],
        quRank: [
          {
            required: true,
            message: '请填写区排名',
            trigger: 'blur'
          }
        ],
        'extendProd.zhongkaobaomingsuozaiqu': [
          {
            required: true,
            message: '请选择中考报名所在区',
            trigger: 'change'
          }
        ],
        yimoxiaoRank: [
          {
            required: true,
            message: '请填写校排名',
            trigger: 'blur'
          }
        ],
        yimoquRank: [
          {
            required: true,
            message: '请填写区排名',
            trigger: 'blur'
          }
        ]
      },
      hujiqvxiaoQiTaNameRules: false,
      xuejisuozaiquQitaRules: false,
      zhongkaobaomingsuozaiquQitaRules: false,
      // 民族列表
      nationList: [
        {
          id: "01",
          name: "汉族"
        }, {
          id: "02",
          name: "蒙古族"
        }, {
          id: "03",
          name: "回族"
        },
        {
          id: "04",
          name: "藏族"
        }, {
          id: "05",
          name: "维吾尔族"
        }, {
          id: "06",
          name: "苗族"
        },
        {
          id: "07",
          name: "彝族"
        }, {
          id: "08",
          name: "壮族"
        }, {
          id: "09",
          name: "布依族"
        },
        {
          id: "10",
          name: "朝鲜族"
        }, {
          id: "11",
          name: "满族"
        }, {
          id: "12",
          name: "侗族"
        },
        {
          id: "13",
          name: "瑶族"
        }, {
          id: "14",
          name: "白族"
        }, {
          id: "15",
          name: "土家族"
        },
        {
          id: "16",
          name: "哈尼族"
        }, {
          id: "17",
          name: "哈萨克族"
        }, {
          id: "18",
          name: "傣族"
        },
        {
          id: "19",
          name: "黎族"
        }, {
          id: "20",
          name: "傈僳族"
        }, {
          id: "21",
          name: "佤族"
        },
        {
          id: "22",
          name: "畲族"
        }, {
          id: "23",
          name: "高山族"
        }, {
          id: "24",
          name: "拉祜族"
        },
        {
          id: "25",
          name: "水族"
        }, {
          id: "26",
          name: "东乡族"
        }, {
          id: "27",
          name: "纳西族"
        },
        {
          id: "28",
          name: "景颇族"
        }, {
          id: "29",
          name: "柯尔克孜族"
        }, {
          id: "30",
          name: "土族"
        },
        {
          id: "31",
          name: "达斡尔族"
        }, {
          id: "32",
          name: "仫佬族"
        }, {
          id: "33",
          name: "羌族"
        },
        {
          id: "34",
          name: "布朗族"
        }, {
          id: "35",
          name: "撒拉族"
        }, {
          id: "36",
          name: "毛难族"
        },
        {
          id: "37",
          name: "仡佬族"
        }, {
          id: "38",
          name: "锡伯族"
        }, {
          id: "39",
          name: "阿昌族"
        },
        {
          id: "40",
          name: "普米族"
        }, {
          id: "41",
          name: "塔吉克族"
        }, {
          id: "42",
          name: "怒族"
        },
        {
          id: "43",
          name: "乌孜别克族"
        }, {
          id: "44",
          name: "俄罗斯族"
        }, {
          id: "45",
          name: "鄂温克族"
        },
        {
          id: "46",
          name: "崩龙族"
        }, {
          id: "47",
          name: "保安族"
        }, {
          id: "48",
          name: "裕固族"
        },
        {
          id: "49",
          name: "京族"
        }, {
          id: "50",
          name: "塔塔尔族"
        }, {
          id: "51",
          name: "独龙族"
        },
        {
          id: "52",
          name: "鄂伦春族"
        }, {
          id: "53",
          name: "赫哲族"
        }, {
          id: "54",
          name: "门巴族"
        },
        {
          id: "55",
          name: "珞巴族"
        }, {
          id: "56",
          name: "基诺族"
        }],
      cityList: [
        {
          value: '110101',
          label: '东城区'
        },
        {
          value: '110102',
          label: '西城区'
        },
        {
          value: '110105',
          label: '朝阳区'
        },
        {
          value: '110106',
          label: '丰台区'
        },
        {
          value: '110107',
          label: '石景山区'
        },
        {
          value: '110108',
          label: '海淀区'
        },
        {
          value: '110109',
          label: '门头沟区'
        },
        {
          value: '110111',
          label: '房山区'
        },
        {
          value: '110112',
          label: '通州区'
        },
        {
          value: '110113',
          label: '顺义区'
        },
        {
          value: '110114',
          label: '昌平区'
        },
        {
          value: '110115',
          label: '大兴区'
        },
        {
          value: '110116',
          label: '怀柔区'
        },
        {
          value: '110117',
          label: '平谷区'
        },
        {
          value: '110228',
          label: '密云区'
        },
        {
          value: '110229',
          label: '延庆区'
        },
        {
          value: '110230',
          label: '其他'
        }],
      noList: ['数学探索', '人工智能', '物理实践', '高尔夫', '钢琴', '舞蹈', '声乐', '钢琴', '戏曲'],
      // 专业成绩
      zhuanyeData: [
        {
          zhuanyechengjiname: '',
          zhuanyechengjirank: '',
          zhuanyechengjiscore: '',
          zhuanyechengjiplace: '',
          zhuanyechengjizhengshu: '',
          zhuanyechengjiURL: ''
        }
      ]
    }
  },
  computed: {},
  watch: {
    'form.chinese': 'calcTotalScore',
    'form.math': 'calcTotalScore',
    'form.english': 'calcTotalScore',
    'form.physics': 'calcTotalScore',
    'form.politics': 'calcTotalScore',
    'form.yimochinese': 'calcYimoTotalScore',
    'form.yimomath': 'calcYimoTotalScore',
    'form.yimoenglish': 'calcYimoTotalScore',
    'form.yimophysics': 'calcYimoTotalScore',
    'form.yimopolitics': 'calcYimoTotalScore'
  },
  methods: {
    calcTotalScore () {
      this.form.totalScore = (this.form.chinese || 0) + (this.form.math || 0) + (this.form.english || 0) + (this.form.physics || 0) + (this.form.politics || 0)
    },
    calcYimoTotalScore () {
      this.form.yimototalScore = (this.form.yimochinese || 0) + (this.form.yimomath || 0) + (this.form.yimoenglish || 0) + (this.form.yimophysics || 0) + (this.form.yimopolitics || 0)
    },
    // 获取填报单
    getApplication () {
      const params = {
        applicationId: this.$route.query.applicationId,
        applicantToken: this.$route.query.applicantToken
      }
      this.$axios.get(window.baseURL + `/galaxy/baoming/api/v1/huaxia/applicant/getApplicationInfo?${Qs.stringify(params)}`)
        .then(result => {
          const res = result.data
          if (result.code === '1000000' && res && JSON.stringify(res) !== '{}') {
            if (res.fillFormSn) {
              this.form.fillFormSn = res.fillFormSn
            } else {
              this.getFillFormSn()
            }
            // 判断是否能修改
            if (Number(this.$route.query.fillEnable) === 1) {
              if (res.updateEnableFlag === 1) {
                this.disabledForm = false
              } else if (res.updateEnableFlag === 0) {
                this.disabledForm = true
              }
            } else if (Number(this.$route.query.fillEnable) === 0) {
              this.disabledForm = true
            }
            // 判断是否被录取
            if (res.showResult) {
              this.resultDialog = true
              this.dealState = res.dealState
              this.getNotifyConfirmStatus()
            } else {
              this.getState()
            }
            const domain = 'https://' + (res.bucketDomainName || '')
            this.form.name = res.name || ''
            this.form.sex = res.sex || ''
            this.form.birthday = res.birthday || ''
            this.form.chuzhongSchool = res.chuzhongSchool || ''
            this.form.xuejisuozaiqu = res.xuejisuozaiqu || ''
            this.form.xuejisuozaiquQita = res.xuejisuozaiquQita || ''
            this.form.idNo = res.idNo || ''
            this.form.zhongkaoNo = res.zhongkaoNo || ''
            this.form.photo = res.photo || ''
            this.photoPreview = res.photo ? (domain + res.photo + '?x-oss-process=style/preview') : ''
            this.form.hujiqvxiao = res.hujiqvxiao || ''
            this.form.hujiqvxiaoQiTaName = res.hujiqvxiaoQiTaName || ''
            this.form.eduId = res.eduId || ''
            this.form.faName = res.faName || ''
            this.form.maName = res.maName || ''
            this.form.faPhone = res.faPhone || ''
            this.form.maPhone = res.maPhone || ''
            this.form.faGongzuoDanwei = res.faGongzuoDanwei || ''
            this.form.maGongzuoDanwei = res.maGongzuoDanwei || ''
            this.form.faGongzuopost = res.faGongzuopost || ''
            this.form.maGongzuopost = res.maGongzuopost || ''
            this.form.extrarelationGongzuopost = res.extrarelationGongzuopost || ''
            this.form.extrarelation = res.extrarelation || ''
            this.form.extrarelationName = res.extrarelationName || ''
            this.form.extrarelationGongzuoDanwei = res.extrarelationGongzuoDanwei || ''
            this.form.extrarelationPhone = res.extrarelationPhone || ''
            this.form.chinese = res.chinese || undefined
            this.form.math = res.math || undefined
            this.form.english = res.english || undefined
            this.form.physics = res.physics || undefined
            this.form.politics = res.politics || undefined
            this.form.totalScore = res.totalScore || undefined
            this.form.xiaoRank = res.xiaoRank || undefined
            this.form.quRank = res.quRank || undefined
            this.form.yimochinese = res.yimochinese || undefined
            this.form.yimomath = res.yimomath || undefined
            this.form.yimoenglish = res.yimoenglish || undefined
            this.form.yimopolitics = res.yimopolitics || undefined
            this.form.yimototalScore = res.yimototalScore || undefined
            this.form.yimoxiaoRank = res.yimoxiaoRank || undefined
            this.form.yimoquRank = res.yimoquRank || undefined
            this.form.yimophysics = res.yimophysics || undefined
            this.form.zhongkaoyingyu = res.zhongkaoyingyu || undefined
            this.form.baokaozhuanxiang = res.baokaozhuanxiang || undefined
            this.form.baokaoxiaoxiang = res.baokaoxiaoxiang || undefined
            this.form.extendProd = res.extendProd || {
              remark: '',
              yimoRemark: '',
              baokaofenlei: '科技',
              baomingqumu: '',
              shifouhechangbanzou: '',
              zhongkaobaomingsuozaiqu: '',
              zhongkaobaomingsuozaiquQita: ''
            }
            this.zhuanyeData = res.zhuanyechengji || []
            this.form.otherDesc = res.otherDesc || ''
          }
        })
    },
    // 新申请填报,获取串号
    getFillFormSn () {
      this.$axios.get(window.baseURL + `/galaxy/baoming/api/v1/huaxia/applicant/getFillFormSn`)
        .then(result => {
          const res = result.data
          if (result.code === '1000000' && res && JSON.stringify(res) !== '{}') {
            this.form.fillFormSn = res.fillFormSn
          } else {
            this.form.fillFormSn = ''
          }
        })
    },

    // 提交表单
    submitForm (formName) {
      const that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.noList.includes(this.form.baokaozhuanxiang) && !this.form.baokaoxiaoxiang) {
            Message(
              {
                type: 'warning',
                message: '请选择报考专项小项',
                duration: 1000
              }
            )
            return false
          }
          if (that.form.xuejisuozaiqu === '110230' && !that.form.xuejisuozaiquQita.trim()) {
            this.xuejisuozaiquQitaRules = true
            Message(
              {
                type: 'warning',
                message: '信息填写不完整',
                duration: 800
              }
            )
            return false
          }
          if (that.form.extendProd.zhongkaobaomingsuozaiqu === '110230' && !that.form.extendProd.zhongkaobaomingsuozaiquQita.trim()) {
            this.zhongkaobaomingsuozaiquQitaRules = true
            Message(
              {
                type: 'warning',
                message: '信息填写不完整',
                duration: 800
              }
            )
            return false
          }
          if (that.form.hujiqvxiao === '110230' && !that.form.hujiqvxiaoQiTaName.trim()) {
            this.hujiqvxiaoQiTaNameRules = true
            Message(
              {
                type: 'warning',
                message: '信息填写不完整',
                duration: 800
              }
            )
            return false
          }
          if (that.form.xuejisuozaiqu !== '110230') {
            that.form.xuejisuozaiquQita = ''
          }
          if (that.form.extendProd.zhongkaobaomingsuozaiqu !== '110230') {
            that.form.extendProd.zhongkaobaomingsuozaiquQita = ''
          }
          if (that.form.hujiqvxiao !== '110230') {
            that.form.hujiqvxiaoQiTaName = ''
          }
          that.form.zhuanyechengji = JSON.parse(JSON.stringify(that.zhuanyeData))
          let hasDownloadedCommitment = false
          const commitmentDownloadLinkId = `commitment-download-link-${Date.now()}`
          const confirmPromise = MessageBox.confirm(`\u3000\u3000本人郑重承诺：所填报的全部个人信息、特长资质及相关证明材料均真实、准确、完整。<br>
  \u3000\u3000如有任何虚假陈述、隐瞒事实或提交不实材料的情形，本人自愿接受以下处理措施：<br>
  \u3000\u30001. 立即退出本次特长生考试及录取程序；<br>
  \u3000\u30002. 无条件接受学校取消考试成绩、录取资格等决定；<br>
  \u3000\u30003. 承担因信息不实产生的一切法律后果及责任。<br>
<span class="commitment-desc">请下载承诺书，打印并且签字。初审通过后，参加测试时携带<br>签字承诺书。</span>
<a id="${commitmentDownloadLinkId}" class="commitment-download-file" href="https://bs-application-resource.oss-cn-beijing.aliyuncs.com/%E5%8C%97%E4%BA%AC%E5%B8%88%E8%8C%83%E5%A4%A7%E5%AD%A6%E9%99%84%E5%B1%9E%E5%AE%9E%E9%AA%8C%E4%B8%AD%E5%AD%A6%E7%89%B9%E9%95%BF%E7%94%9F%E6%B5%8B%E8%AF%95%E5%AD%A6%E7%94%9F%E6%89%BF%E8%AF%BA%E4%B9%A6.pdf" download="北京师范大学附属实验中学特长生测试学生承诺书.pdf">
  <span class="commitment-download-name"><img class="commitment-file-icon" src="${commitmentFileIcon}" alt=""><span>北京师范大学附属实验中学特长生测试学生承诺书.pdf</span></span>
  <span class="commitment-download-action"><img class="commitment-download-icon" src="${commitmentDownloadIcon}" alt=""><span>下载</span></span>
</a>`,
          '确认声明',
          {
            confirmButtonText: '同意并提交',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            customClass: 'commitment-message-box',
            closeOnClickModal: false,
            beforeClose: (action, instance, done) => {
              if (action === 'confirm' && !hasDownloadedCommitment) {
                Message({
                  type: 'warning',
                  message: '请先下载承诺书',
                  duration: 1000
                })
                return
              }
              done()
            }
          })
          setTimeout(() => {
            const downloadLink = document.getElementById(commitmentDownloadLinkId)
            if (!downloadLink) return
            downloadLink.addEventListener('click', () => {
              hasDownloadedCommitment = true
            }, { once: true })
          }, 0)
          confirmPromise.then(() => {
            that.$axios.post(window.baseURL + '/galaxy/baoming/api/v1/huaxia/applicant/submitApplication', that.form)
              .then(result => {
                const res = result.data
                const url = window.location.href
                const params = new URL(url).searchParams
                const batchId = params.get('batchId')
                if (result.code === '1000000' && res) {
                  Message(
                    {
                      type: 'success',
                      message: '提交成功',
                      duration: 800,
                      onClose () {
                        that.$router.push(
                          {
                            path: "/success",
                            query: {
                              applicationId: res,
                              applicantToken: that.$route.query.applicantToken,
                              batchState: that.$route.query.batchState,
                              fillEnable: that.$route.query.fillEnable,
                              batchId
                            }
                          }
                        )
                      }
                    }
                  )
                }
              })
          })
        } else {
          Message(
            {
              type: 'warning',
              message: '请根据上方红色提示，将个人信息填写完整',
              duration: 1500
            }
          )
        }
      })
    },
    // 保存表单
    saveForm () {
      if (!this.form.eduId) {
        Message(
          {
            type: 'warning',
            message: '教育ID不能为空',
            duration: 1000
          }
        )
        return false
      }
      if (this.form.name.length > 50) {
        Message(
          {
            type: 'warning',
            message: '姓名长度应在50字以内',
            duration: 1000
          }
        )
        return false
      }
      if (this.form.chuzhongSchool.length > 50) {
        Message(
          {
            type: 'warning',
            message: '初中（学籍）所在校长度不能超过50',
            duration: 1000
          }
        )
        return false
      }
      if (this.form.xuejisuozaiquQita.length > 100) {
        Message(
          {
            type: 'warning',
            message: '初中校所在区具体名称不能超过100',
            duration: 1000
          }
        )
        return false
      }
      if (this.form.extendProd?.zhongkaobaomingsuozaiquQita?.length > 100) {
        Message(
          {
            type: 'warning',
            message: '中考报名所在区具体名称不能超过100',
            duration: 1000
          }
        )
        return false
      }
      if (this.form.zhongkaoNo.length > 100) {
        Message(
          {
            type: 'warning',
            message: '中考报名号长度不能超过100',
            duration: 1000
          }
        )
        return false
      }
      if (this.form.hujiqvxiaoQiTaName.length > 100) {
        Message(
          {
            type: 'warning',
            message: '户籍所在县区具体名称不能超过100',
            duration: 1000
          }
        )
        return false
      }
      if (this.form.eduId.length > 50) {
        Message(
          {
            type: 'warning',
            message: '教育ID号长度不能超过50',
            duration: 1000
          }
        )
        return false
      }
      if (this.form.faName.length > 50) {
        Message(
          {
            type: 'warning',
            message: '姓名长度应在50字以内',
            duration: 1000
          }
        )
        return false
      }
      if (this.form.maName.length > 50) {
        Message(
          {
            type: 'warning',
            message: '姓名长度应在50字以内',
            duration: 1000
          }
        )
        return false
      }
      if (this.form.extrarelationName.length > 50) {
        Message(
          {
            type: 'warning',
            message: '姓名长度应在50字以内',
            duration: 1000
          }
        )
        return false
      }
      if (this.form.extrarelation.length > 50) {
        Message(
          {
            type: 'warning',
            message: '关系长度应在50字以内',
            duration: 1000
          }
        )
        return false
      }
      const phoneReg = /^[1][3,4,5,7,8][0-9]{9}$/
      if (this.form.faPhone && !phoneReg.test(this.form.faPhone)) {
        Message(
          {
            type: 'warning',
            message: '请输入合法的手机号',
            duration: 1000
          }
        )
        return false
      }
      if (this.form.maPhone && !phoneReg.test(this.form.maPhone)) {
        Message(
          {
            type: 'warning',
            message: '请输入合法的手机号',
            duration: 1000
          }
        )
        return false
      }
      if (this.form.extrarelationPhone && !phoneReg.test(this.form.extrarelationPhone)) {
        Message(
          {
            type: 'warning',
            message: '请输入合法的手机号',
            duration: 1000
          }
        )
        return false
      }
      if (this.form.faGongzuoDanwei.length > 50) {
        Message(
          {
            type: 'warning',
            message: '工作单位长度应在50字以内',
            duration: 1000
          }
        )
        return false
      }
      if (this.form.maGongzuoDanwei.length > 50) {
        Message(
          {
            type: 'warning',
            message: '工作单位长度应在50字以内',
            duration: 1000
          }
        )
        return false
      }
      if (this.form.extrarelationGongzuoDanwei.length > 50) {
        Message(
          {
            type: 'warning',
            message: '工作单位长度应在50字以内',
            duration: 1000
          }
        )
        return false
      }
      if (this.form.xuejisuozaiqu !== '110230') {
        this.form.xuejisuozaiquQita = ''
      }
      if (this.form.extendProd.zhongkaobaomingsuozaiqu !== '110230') {
        this.form.extendProd.zhongkaobaomingsuozaiquQita = ''
      }
      if (this.form.hujiqvxiao !== '110230') {
        this.form.hujiqvxiaoQiTaName = ''
      }
      this.form.zhuanyechengji = JSON.parse(JSON.stringify(this.zhuanyeData))
      this.$axios.post(window.baseURL + '/galaxy/baoming/api/v1/huaxia/applicant/saveApplication', this.form)
        .then(result => {
          const res = result.data
          if (result.code === '1000000' && res) {
            const url = window.location.href
            const params = new URL(url).searchParams
            const batchId = params.get('batchId')
            const query = {
              applicationId: res,
              applicantToken: this.$route.query.applicantToken,
              batchState: this.$route.query.batchState,
              fillEnable: this.$route.query.fillEnable,
              batchId
            }
            Message({
              type: 'success',
              message: '保存成功',
              duration: 1000,
              onClose () {
                window.location.href = window.location.origin + window.location.pathname + '?' + Qs.stringify(query)
              }
            })
          }
        })
    },
    // 删除个人证件照
    deletePhoto () {
      this.$refs.photo.uploadFiles.splice(0, 1)
      this.form.photo = ''
      this.photoPreview = ''
    },
    // 个人证件照上传
    photoBeforeUpload (file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        Message({
          type: 'error',
          message: '上传文件类型只能是jpg格式的图片!',
          duration: 1000
        });
        return false
      }
      if (!isLt2M) {
        Message({
          type: 'error',
          message: '上传图片大小不能超过2M!',
          duration: 1000
        });
        return false
      }
    },
    getState () {
      this.$axios.post(window.baseURL + '/galaxy/baoming/api/v1/huaxia/applicant/batchInfo').then(async result => {
        const res = result.data
        if (res?.batchState === 'prepared') {
          await MessageBox({
            message: '学生信息采集暂未开始',
            title: '未开始',
            showConfirmButton: false,
            distinguishCancelAndClose: false,
            closeOnPressEscape: false,
            closeOnClickModal: false,
            showCancelButton: false,
            showClose: false
          })
        } else if (res.batchState === 'closed') {
          await MessageBox('学生信息采集已结束', '已结束', { confirmButtonText: '确定' })
        }
      })
    },
    photoUpload (content) {
      const file = content.file;
      this.photoLoading = true
      this.$axios.get(window.baseURL + '/galaxy/baoming/api/v1/huaxia/applicant/getUploadAuthentication?type=idphoto&fillFormSn=' + this.form.fillFormSn)
        .then(async result => {
          const res = result.data
          if (result.code === '1000000' && res && JSON.stringify(res) !== '{}') {
            const params = result.data
            params.file = file
            const url = params.host
            const data = await this.$store.dispatch('setUploadParams', params);
            this.$store.dispatch('uploadFile', {
              url,
              data
            })
              .then(res => {
                this.photoLoading = false
                if (res.status === 200) {
                  this.form.photo = `/${params.dir}/${params.ossFileName}`
                  this.photoPreview = url + `/${params.dir}/${params.ossFileName}` + '?x-oss-process=style/preview'
                  Message(
                    {
                      type: 'success',
                      message: '上传成功',
                      duration: 800
                    }
                  )
                }
              })
              .catch(error => {
                console.log(error);
              });
          }
        })
    },

    // 专业成绩证书/作品文件
    beforeUploadCertificate (file) {
      const TYPE = ['image/jpeg', 'application/pdf', 'image/png']
      const isLt5M = file.size / 1024 / 1024 < 5;
      const fileType = file.type;
      console.log(fileType);
      if (!isLt5M) {
        Message(
          {
            type: 'error',
            message: '上传文件大小不能超过5MB'
          }
        );
        return false;
      }
      if (!TYPE.includes(fileType)) {
        Message(
          {
            type: 'error',
            message: '上传文件类型错误'
          }
        );
        return false;
      }
    },
    certificateUpload (content, index) {
      const file = content.file;
      this.$axios.get(window.baseURL + '/galaxy/baoming/api/v1/huaxia/applicant/getUploadAuthentication?type=zhuanye&fillFormSn=' + this.form.fillFormSn)
        .then(async result => {
          const res = result.data
          if (result.code === '1000000' && res && JSON.stringify(res) !== '{}') {
            const params = result.data
            params.file = file
            const url = params.host
            const data = await this.$store.dispatch('setUploadParams', params);
            this.$store.dispatch('uploadFile', {
              url,
              data
            })
              .then(res => {
                if (res.status === 200) {
                  this.zhuanyeData[index].zhuanyechengjizhengshu = params.file.name
                  this.zhuanyeData[index].zhuanyechengjiURL = `/${params.dir}/${params.ossFileName}`
                  Message(
                    {
                      type: 'success',
                      message: '上传成功',
                      duration: 800
                    }
                  )
                }
              })
              .catch(error => {
                console.log(error);
              });
          }
        })
    },
    // 删除行
    deleteRow (scope) {
      this.zhuanyeData.splice(scope.$index, 1)

      if (this.zhuanyeData.length !== scope.$index) {
        for (let i = scope.$index; i <= this.zhuanyeData.length; i++) {
          this.zhuanyeData[i].zhuanyechengjizhengshu = this.zhuanyeData[i + 1]?.zhuanyechengjizhengshu || ''
          this.zhuanyeData[i].zhuanyechengjiURL = this.zhuanyeData[i + 1]?.zhuanyechengjiURL || ''
        }
      }
    },
    // 添加行
    addRow (row) {
      this.zhuanyeData.push({
        zhuanyechengjiname: '',
        zhuanyechengjirank: '',
        zhuanyechengjiscore: '',
        zhuanyechengjiplace: '',
        zhuanyechengjizhengshu: '',
        zhuanyechengjiURL: ''
      })
    },
    submitAttendTestState (state) {
      const confirmStatus = state === 'accept' ? 1 : state === 'reject' ? 2 : 3
      this.$axios.post(`${window.baseURL}/galaxy/baoming/api/v1/huaxia/applicant/confirmNotifyResult`, {
        applicationId: this.form.applicationId,
        confirmStatus,
        applicantToken: this.form.applicantToken
      }).then(result => {
        if (result.code === '1000000') {
          this.testConfirmChoice = state
        }
      })
    },
    confirmAccept () {
      this.acceptPopoverVisible = false
      this.submitAttendTestState('accept')
    },
    confirmReject () {
      this.rejectPopoverVisible = false
      this.submitAttendTestState('reject')
    },
    getNotifyConfirmStatus () {
      this.$axios.get(`${window.baseURL}/galaxy/baoming/api/v1/huaxia/applicant/getNotifyConfirmStatus`, {
        params: {
          applicantToken: this.$route.query.applicantToken,
          applicationId: this.form.applicationId
        }
      }).then(result => {
        if (result.code === '1000000') {
          this.testConfirmChoice = {
            1: 'accept',
            2: 'reject',
            3: 'noted'
          }[result.data.notifyConfirmStatus] || null
        }
      }).finally(() => {
        this.notifyStatusLoading = false
      })
    }

  },
  created () {
    this.form.applicationId = this.$route.query.applicationId
    this.form.applicantToken = this.$route.query.applicantToken
    if (this.$route.query.applicationId) {
      this.form.operationType = 'update'
      this.getApplication()
    } else {
      this.form.operationType = 'save'
      this.getState()
      this.getFillFormSn()
    }
  }
}
</script>

<style lang="scss" scoped>
.personalMessage {
  .color_red {
    color: red;
  }

  .personalMessage_content_maintitle_remark {

    font-size: 12px;
    opacity: 0.6;
    margin-left: 40px;

  }

  width: 1200px;
  margin: 0 auto;
  min-height: 100vh;
  color: rgba($color: #000000, $alpha: .85);

  .personalMessage_header {
    height: 125px;
    background-image: url('../assets/imgs/header.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .personalMessage_header_left {
      display: flex;
      justify-content: space-between;

      .personalMessage_schoolIcon {
        padding-left: 10px;
        width: 443px;
      }

      .personalMessage_systemName {
        display: inline-block;
        font-size: 25px;
        line-height: 81px;
        margin-left: 16px;
        font-weight: bold;
        color: rgba($color: #000000, $alpha: .85);
      }
    }
  }

  .personalMessage_content {
    background-color: #fff;
    padding-bottom: 20px;

    .form_title {
      color: #333;
      font-size: 25px;
      text-align: center;
      padding-top: 30px;
    }

    .personalMessage_content_maintitle {
      padding: 15px 0;
      text-align: center;
      font-size: 25px;
      font-weight: bold;
      color: rgba($color: #000000, $alpha: .85);
    }

    .classTitle {
      margin: 12px 0;
      font-size: 14px;
    }

    .personalMessage_content_module {
      padding: 12px 40px;

      .moduleDesc {
        font-size: 12px;
      }

      .wordShow {
        text-align: center;
        font-size: 16px;
        position: relative;

        img {
          position: absolute;
          top: 6px;
          left: 20px;
        }
      }

      .personalMessage_content_title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 30px;
      }

      .personalMessage_content_title_required {
        position: relative;
        font-weight: normal;

        &::before {
          content: '*';
          font-size: 12px;
          position: absolute;
          top: 0px;
          left: -12px;
          color: #F56C6C;
        }
      }

      .personalMessage_content_tableList {
        width: fit-content;
        border: 1px solid #DCDFE6;

        .personalMessage_content_tableList_header {
          width: fit-content;
          background-color: #1890FF;
          display: flex;
          color: #fff;

          .personalMessage_content_tableList_header_item {
            height: 54px;
            line-height: 54px;
            text-align: left;
            padding: 0 16px;
            border-right: 1px solid rgba(255, 255, 255, .3);

            &:last-child {
              border-right: none;
            }
          }
        }

        .personalMessage_content_tableList_data {
          display: flex;

          .personalMessage_content_tableList_data_item {
            line-height: 40px;
            border-right: 1px solid #DCDFE6;

            &:last-child {
              border-right: none;
            }

            .personalMessage_content_tableList_data_item_cell {
              padding: 4px 16px;
              border-bottom: 1px solid #DCDFE6;
              height: 78px;
              display: flex;
              align-items: center;
              justify-content: center;

              &:last-child {
                border-bottom: none;
              }
            }
          }
        }

        .table_relation {
          width: 110px;

          .el-input {
            width: 100px;
          }
        }

        .table_name {
          width: 280px;

          .el-input {
            width: 240px;
          }
        }

        .table_phone {
          width: 290px;

          .el-input {
            width: 250px;
          }
        }
      }

      .personalMessage_content_title_remark {
        top: 8px;
        font-size: 12px;
        opacity: 0.6;
        margin-left: 10px;
      }

      .personalMessage_content_score {
        .fileName {
          max-width: 150px;
          display: block;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }

  .personalMessage_content_score {
    margin-top: 24px;

    .el-input {
      width: 170px;
    }

    .el-form-item__label {
      width: 70px !important;
    }

    .el-form-item__content {
      margin-left: 70px !important;
    }
  }

  .otherDesc {
    padding: 0 40px;
  }
}

.redstyle {
  color: #f5222d;
}
</style>
<style lang="scss">
.commitment-message-box {
  .el-message-box__message p {
    line-height: 1.5;
  }

  .commitment-desc {
    display: block;
    margin-top: 8px;
    color: #333;
    font-size: 14px;
    line-height: 22px;
  }

  .commitment-download-file {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
    padding: 6px 8px;
    width: 100%;
    border-radius: 4px;
    background: #F4F4F4;
    text-decoration: none;
  }

  .commitment-download-name,
  .commitment-download-action {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    line-height: 1;
    white-space: nowrap;
  }

  .commitment-download-name {
    min-width: 0;
    color: #333;

    span {
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .commitment-file-icon {
      width: 16px;
      height: 16px;
      flex-shrink: 0;
    }
  }

  .commitment-download-action {
    color: #1890FF;
    flex-shrink: 0;

    .commitment-download-icon {
      width: 14px;
      height: 14px;
    }
  }
}

.zhuanyeupload {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .el-upload-dragger {
    width: 1100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .el-upload__tip {
    margin-top: 0;
  }

  .el-upload__text {
    line-height: 22px;
    color: #999;
    font-size: 12px;

    div {
      line-height: 32px;
      color: #666;
      font-size: 14px;
      margin-top: 12px;
    }
  }
}

.first-table {
  thead {
    tr {
      th {

        &:nth-of-type(1),
        &:nth-of-type(2),
        &:nth-of-type(3),
        &:nth-of-type(4),
        &:nth-of-type(5),
        &:nth-of-type(6),
        &:nth-of-type(7),
        &:nth-of-type(8) {
          position: relative;

          &::before {
            content: '*';
            position: absolute;
            top: 16px;
            left: 8px;
            color: #F56C6C;
          }

          .cell {
            padding-left: 20px !important;
          }
        }
      }
    }
  }
}

.resultDialog .el-dialog {
  width: 800px;
  max-width: calc(100vw - 32px);
  text-align: center;

  .rejectResult {
    font-size: 22px;
  }

  .el-dialog__header {
    text-align: left;
  }

  .resultDialog_tip {
    font-size: 16px;
  }

  .resultDialog_test {
    border: 1px dotted #ccc;
    padding: 10px 16px;
  }

  .resultDialog_test_title {
    font-size: 18px;
  }

  .resultDialog_test_content {
    text-align: left;

    .resultDialog_test_item_title {
      font-size: 14px;
      font-weight: bold;
    }

    .resultDialog_test_item_details {
    }
  }

  .resultDialog_ask {
    text-align: left;
    color: #888;
  }

  .resultDialog_action {
    margin-top: 20px;
    text-align: center;
    display: flex;
    justify-content: center;
    gap: 12px;
  }

  .resultDialog_promiseDownload {
    margin-top: 8px;
    text-align: center;
    line-height: 22px;

    a {
      color: #1890FF;
      text-decoration: none;
    }
  }

  div {
    line-height: 40px;
  }

  .link {
    color: #1890FF;
  }
}

.resultDialog .el-dialog .scienceResultNotice {
  width: 680px;
  max-width: 100%;
  margin: 0 auto;
  padding: 4px 0 0;
  color: #111;
  font-family: "SimSun", "宋体", serif;
  font-size: 14px;
  line-height: 24px;
  text-align: left;

  h1 {
    margin: 0 0 12px;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.6;
    text-align: left;
  }

  div,
  p {
    line-height: 24px;
  }

  .scienceResultNotice_title {
    margin-bottom: 4px;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
  }

  .scienceResultNotice_info {
    margin-bottom: 2px;

    span {
      font-weight: 500;
    }
  }

  .scienceResultNotice_table {
    width: 560px;
    margin: 0 auto 4px;
    border-collapse: collapse;
    table-layout: fixed;
    font-size: 14px;
    line-height: 1.45;

    th,
    td {
      border: 1px solid #8f8f8f;
      padding: 4px 8px;
      text-align: center;
      vertical-align: middle;
      font-weight: 400;
    }

    th {
      font-weight: 500;
    }

    th:nth-child(1),
    td:nth-child(1) {
      width: 46px;
    }

    th:nth-child(2),
    td:nth-child(2) {
      width: 116px;
    }

    th:nth-child(3),
    td:nth-child(3) {
      width: 150px;
    }
  }

  td.scienceResultNotice_tableNest {
    padding: 0;
  }

  .scienceResultNotice_showcase {
    display: flex;
    min-height: 100%;
  }

  .scienceResultNotice_showcaseTitle {
    width: 112px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 8px;
    border-right: 1px solid #8f8f8f;
    box-sizing: border-box;
  }

  .scienceResultNotice_showcaseItems {
    flex: 1;

    div {
      height: 27px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #8f8f8f;

      &:last-child {
        border-bottom: 0;
      }
    }
  }

  .scienceResultNotice_notes {
    margin-top: 4px;
  }

  .scienceResultNotice_notesTitle {
    margin-bottom: 4px;
    font-weight: 500;
  }

  p {
    margin: 0 0 3px;
    text-indent: 0;
  }

  .scienceResultNotice_footer {
    margin-top: 18px;
  }

  .scienceResultNotice_signature {
    margin-top: 16px;
    padding-right: 44px;
    text-align: right;
  }
}

@media (max-width: 720px) {
  .scienceResultNotice {
    font-size: 13px;

    h1 {
      margin-bottom: 24px;
      font-size: 15px;
    }

    .scienceResultNotice_table {
      width: 100%;

      th,
      td {
        padding: 4px;
      }
    }

    .scienceResultNotice_signature {
      padding-right: 0;
    }
  }
}

.confirmPop {
  text-align: center;
  padding: 4px 0;

  p {
    margin: 0 0 10px;
    line-height: 1.5;
    font-size: 14px;
  }

  .confirmPop_btns {
    .el-button + .el-button {
      margin-left: 8px;
    }
  }
}

.personalMessage {
  .el-table {
    margin-top: 8px;

    th {
      background-color: #FAFAFA;
      padding: 15px 0;
    }

    td {
      padding: 16px 0;
    }

    .cell {
      overflow: visible;
    }

    .el-form-item {
      margin-bottom: 0;
    }

    .el-input {
      width: 100% !important;
    }

    .el-form-item__content {
      margin-left: 0 !important;
    }
  }

  .highestRank {
    position: relative;

    .el-form-item {
      display: block !important;
    }

    .el-form-item__label {
      display: block !important;
      width: 100% !important;
    }

    .el-form-item__content {
      margin-left: 0 !important;
      display: block !important;
      width: 100%;
    }

    .el-checkbox-group {
      margin-top: 20px;
    }

    .el-checkbox {
      width: 100%;
    }

    .highestRankTime {
      .highestRankTime_input {
        height: 46px;
      }
    }
  }

  .upload_container {
    display: inline-block;
  }

  .el-dialog {
    margin-top: 2vh !important;
  }

  .el-icon-video-camera-solid {
    font-size: 24px;
    color: #000;
    margin-right: 6px;
  }

  .el-icon-zoom-in,
  .el-icon-delete {
    font-size: 30px;
    color: #fff;
    margin: 0 6px;
    cursor: pointer;
  }

  .el-icon-success {
    font-size: 18px;
    color: #52C41A;
    margin-right: 6px;
  }

  .el-input__icon {
    height: auto;
  }

  .el-date-editor {
    i {
      line-height: 32px !important;
    }
  }

  .personalMessage_header_right .el-button {
    border-radius: 0;
    background-color: #1890FF;
    width: 96px;
    height: 40px;
  }

  .el-form-item__label {
    font-size: 14px;
    color: rgba($color: #000000, $alpha: .85);
  }

  .el-select {
    width: 328px;
  }

  .el-input {
    width: 328px;
    height: 32px;
    line-height: 32px;

    .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
  }

  .hujiqvxiao,
  .xuejisuozaiqu,
  .zhongkaobaomingsuozaiqu {
    .el-select {
      width: 160px;

      .el-input {
        width: 160px;
      }
    }
  }

  .zhongkaobaomingsuozaiqu {
    label {
      &::before {
        content: '*';
        color: #F56C6C;
        margin-right: 4px;
      }
    }
  }

  .personalPhoto {
    .el-form-item__label {
      width: 100% !important;
    }

    .el-form-item__content {
      margin-left: 0 !important;
      position: relative;

      .photoPreview {
        width: 124px;
        height: 155px;
        border-radius: 6px;
        border: 1px solid #c0ccda;
        position: absolute;
        top: 40px;
        overflow: hidden;
        left: 0px;

        &:hover {
          .photoPreview_modal {
            display: block;
          }
        }

        .photoPreview_modal {
          width: 100%;
          height: 100%;
          text-align: center;
          line-height: 155px;
          position: absolute;
          top: 0;
          display: none;
          left: 0;
          background-color: rgba($color: #000000, $alpha: .75);
        }
      }
    }

    .el-upload {
      padding-top: 50px;
      width: 124px;
      height: 155px;
      line-height: 30px;
    }

    .el-upload-list__item {
      width: 124px;
      height: 155px;
    }

    .el-upload__tip {
      line-height: 22px;
      color: rgba($color: #000000, $alpha: .45);
      font-size: 14px;
    }
  }

  .hujiqvxiaoQiTaName,
  .xuejisuozaiquQita,
  .zhongkaobaomingsuozaiquQita {
    margin-left: 8px;
    position: relative;

    .el-form-item__content {
      margin-left: 0 !important;
    }

    .el-input {
      width: 160px;
    }
  }

  .personalMessage_content_tableList {
    .el-input {

      // height: 24px;
      .el-input__inner {
        // height: 24px;
      }
    }

    .el-form-item {
      margin-bottom: 0;
    }

    .el-form-item__content {
      margin-left: 0 !important;
    }

    .el-form-item__label {
      width: 0 !important;
    }
  }

  .formFooter {
    padding: 20px 0 0;

    .el-form-item__content {
      margin-left: 40px !important;
    }
  }

  .purple {
    background-color: #1890FF !important;
    border-color: #1890FF !important;

    &:hover {
      background-color: #1890FF;
      border-color: #1890FF;
      color: #fff;
    }
  }

  .default:hover {
    background: #FFF;
    border: 1px solid #DCDFE6;
    color: #606266;
  }

  .personalMessage_content_zhuanxiang {

    .baokaofenlei,
    .baomingxiaoxiang,
    .qumumingcheng {
      label {
        &::before {
          content: '*';
          color: #F56C6C;
          margin-right: 4px;
        }
      }
    }

    .hechangbanzou > label {
      &::before {
        content: '*';
        color: #F56C6C;
        margin-right: 4px;
      }
    }

    .noList {
      label {
        &::before {
          content: none !important;
        }
      }
    }

    .el-row {
      .el-col {
        .el-select {
          width: 265px;

          .el-input {
            width: 265px !important;
          }
        }
      }
    }
  }
}
</style>
